export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: 'AIzaSyAXdRBwSkzzJ_H4wY5QDx91kIN8TKSquJQ',
    authDomain: 'kitty-on-demand-dev.firebaseapp.com',
    projectId: 'kitty-on-demand-dev',
    storageBucket: 'kitty-on-demand-dev.firebasestorage.app',
    messagingSenderId: '206569175958',
    appId: '1:206569175958:web:88a05440be14b36c303bb7',
    measurementId: 'G-WZNVFC197G',
  },
};
